export const iconFontAwesomeUsersPeopleUserLock = (
	<i className="fa-solid fa-user-lock"></i>
);
